import i18n from '@/locales/i18n'
import {
    DETECTION_ROUTE,
    PRESENCE_ROUTE,
    TRIPS_PERSONS_ROUTE,
    TRIPS_ROUTE,
    TRIPS_SHUTTLES_ROUTE
} from '@/router/routes'
import type { RouteType } from '@/types/Route'
import { ref } from 'vue'
import { EDetectionActions } from '../../store/detectionStore/DetectionStoreTypes'
import { EDetectionsPerm } from '../../types/permissions/DetectionsPermissionsEnum'
import { EWebSocketPerm } from '../../types/permissions/WebSocketPermissionsEnum'
import PresencesTable from '../../views/DetectionsView/EDFDetections/PresencesTable.vue'
import ReadsTable from '../../views/DetectionsView/EDFDetections/ReadsTable.vue'
import TripsPersonsTable from '../../views/DetectionsView/EDFDetections/TripsPersonsTable.vue'
import TripsShuttlesTable from '../../views/DetectionsView/EDFDetections/TripsShuttlesTable.vue'
import TripsTable from '../../views/DetectionsView/EDFDetections/TripsTable.vue'

export enum EDetectionsRoutesNames {
    DETECTION_TABLE = 'detectionTable',
    PRESENCE_TABLE = 'presenceTable',
    TRIPS_TABLE = 'tripsTable',
    TRIPS_PERSONS = 'tripsPersonsTable',
    TRIPS_SHUTTLES = 'tripsShuttlesTable'
}
export const EDetectionsRoutesNamesValues = [EDetectionsRoutesNames.DETECTION_TABLE]
export const EPresencesRoutesNamesValues = [EDetectionsRoutesNames.PRESENCE_TABLE]
export const ETripsRoutesNamesValues = [EDetectionsRoutesNames.TRIPS_TABLE]
export const ETripsPersonsRoutesNamesValues = [EDetectionsRoutesNames.TRIPS_PERSONS]
export const ETripsShuttlesRoutesNamesValues = [EDetectionsRoutesNames.TRIPS_SHUTTLES]

const routes: RouteType[] = [
    {
        path: DETECTION_ROUTE,
        name: EDetectionsRoutesNames.DETECTION_TABLE,
        component: ReadsTable,
        props: {
            storeAction: EDetectionActions.FETCH_DETECTIONS
        },
        meta: {
            title: ref(i18n.global.t('menu.detections')),
            permission: EWebSocketPerm.WEBSOCKET_ACCESS
        }
    },
    {
        path: PRESENCE_ROUTE,
        name: EDetectionsRoutesNames.PRESENCE_TABLE,
        component: PresencesTable,
        props: {
            storeAction: EDetectionActions.FETCH_PRESENCES
        },
        meta: {
            title: ref(i18n.global.t('menu.presences')),
            permission: EDetectionsPerm.DETECTIONS_VIEW
        }
    },
    {
        path: TRIPS_ROUTE,
        name: EDetectionsRoutesNames.TRIPS_TABLE,
        component: TripsTable,
        props: {
            storeAction: EDetectionActions.FETCH_TRIPS
        },
        meta: {
            title: ref(i18n.global.t('menu.trips')),
            permission: EDetectionsPerm.DETECTIONS_VIEW
        }
    },

    {
        path: TRIPS_PERSONS_ROUTE,
        name: EDetectionsRoutesNames.TRIPS_PERSONS,
        component: TripsPersonsTable,
        props: {
            storeAction: EDetectionActions.FETCH_PERSONS_TRIPS
        },
        meta: {
            title: ref(i18n.global.t('menu.personsTrips')),
            permission: EDetectionsPerm.DETECTIONS_VIEW
        }
    },
    {
        path: TRIPS_SHUTTLES_ROUTE,
        name: EDetectionsRoutesNames.TRIPS_SHUTTLES,
        component: TripsShuttlesTable,
        props: {
            storeAction: EDetectionActions.FETCH_SHUTTLES_TRIPS
        },
        meta: {
            title: ref(i18n.global.t('menu.shuttlesTrips')),
            permission: EDetectionsPerm.DETECTIONS_VIEW
        }
    }
    /* {
        path: `${EVENTS_ROUTE}${PRESENCE_ROUTE}/:id`,
        name: 'detectionDetail',
        component: DetectionsTableView,
        meta: {
            title: ref(i18n.global.t('menu.detections',
            permission: EDetectionsPerm.DETECTIONS_VIEW
        }
    } */
]

export default routes
